import { useStore } from 'vuex';
import Fitting from '@/models/Fitting';

export default function useConvertFittingsToBasketLines()
{
    const store = useStore();

    /**
     * Convert the fittings currently being edited by the user to basket lines,
     * and add them to the "addToBasket" context.
     */
    class ConvertFittingsToBasketLines
    {
        async handle()
        {
            const promises = [];
            for(const side of ['right', 'left'])
            {
                /** @type {?Fitting} */
                const fitting = store.getters['lensOrder/getFitting'](side);
                if(!fitting)
                {
                    continue;
                }

                promises.push(store.dispatch(
                    'basket/prepareLinesForSaving',
                    fitting.toBasketLine()
                ));
            }

            return await Promise.all(promises);
        }
    }

    return ConvertFittingsToBasketLines;
}
